import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as PusherPushNotifications from "@pusher/push-notifications-web";
import { Modal } from "reactstrap";
import { Modal as ModalAntd, Layout } from "antd";

import HttpClient from "./utils/HttpClient";
import AnnotationsCreate from "@/components/annotations/CreateAnnotation";
import TaskBoard from "@/components/taskManagement/TaskBoard";
import BoardDetail from "@/components/taskManagement/BoardDetail";

const Sidebar = React.lazy(() => import("@/layout/Sidebar"));
const Header = React.lazy(() => import("@/layout/Header"));
const Footer = React.lazy(() => import("@/layout/Footer"));
// const name = React.lazy(() => import('@/'));
// const AnnotationsCreate = React.lazy(() => import('@/components/annotations/CreateAnnotation'));
// import AnnotationsUpdate from './components/annotations/EditAnnotation';
const IndexAnnotations = React.lazy(() =>
    import("@/components/annotations/IndexAnnotation")
);
const AnnotationsUpload = React.lazy(() =>
    import("@/components/annotations/UploadAnnotation")
);
const IndexPricingPlans = React.lazy(() =>
    import("@/components/settings/pricingPlans/IndexPricingPlans")
);
const Settings = React.lazy(() =>
    import("@/components/settings/IndexSettings")
);
const Profile = React.lazy(() => import("@/components/settings/Profile"));
const PaymentHistory = React.lazy(() =>
    import("@/components/settings/pricingPlans/PaymentHistory")
);
const Accounts = React.lazy(() => import("@/components/settings/Accounts"));
// const FacebookAccounts = React.lazy(() => import('@/components/settings/facebookaccounts/FacebookAccountsIndex'));
// const UserDevices = React.lazy(() => import('@/components/settings/devices/UserDevicesIndex'));
const UserActivityLog = React.lazy(() =>
    import("@/components/settings/activityLogs/ActivityLogsIndex")
);
// const DataSourceIndex = React.lazy(() => import('@/components/DataSource/DataSourceIndex'));
const IndexAPIKey = React.lazy(() => import("@/components/apiKey/IndexAPIKey"));
const CreatePayment = React.lazy(() =>
    import("@/components/settings/pricingPlans/CreatePayment")
);
const IntegrationsIndex = React.lazy(() =>
    import("@/components/integrations/IntegrationsIndex")
);
const MyIntegrationsIndex = React.lazy(() =>
    import("@/components/integrations/MyIntegrationsIndex")
);
const SupportIndex = React.lazy(() =>
    import("@/components/support/supportIndex")
);
const IndexUsers = React.lazy(() =>
    import("@/components/settings/user/IndexUsers")
);
// const CreateUser = React.lazy(() => import('@/components/settings/user/CreateUser'));
// const EditUser = React.lazy(() => import('@/components/settings/user/EditUser'));
const IndexNotificationSettings = React.lazy(() =>
    import(
        "@/components/NotificationSettings/IndexNotificationSettingsComponent"
    )
);
const AnalyticsAndBusinessIntelligenceIndex = React.lazy(() =>
    import("@/components/analyticsAndBusinessIntelligence/Index")
);
// const CreatePaymentDetail = React.lazy(() => import('@/components/settings/CreatePaymentDetail'));
const ConsoleSiteModal = React.lazy(() => import("@/helpers/ConsoleSiteModal"));
const AddNewPasswordModal = React.lazy(() =>
    import("@/helpers/AddNewPasswordModal")
);
const AddWebsiteModal = React.lazy(() => import("@/helpers/AddWebsiteModal"));
const IndexDashboard = React.lazy(() =>
    import("@/components/dashboard/IndexDashboard")
);
const IndexAnalytics = React.lazy(() =>
    import("@/components/dashboard/analytics/IndexAnalytics")
);

const IndexInsightsAI = React.lazy(() =>
    import("@/components/dashboard/analytics/IndexInsightsAI")
);

// const IndexSearchConsole = React.lazy(() => import('@/components/dashboard/searchConsole/IndexSearchConsole'));
const SiteRenamedTopNotice = React.lazy(() =>
    import("@/utils/SiteRenamedTopNotice")
);
const UserRegistrationOffer = React.lazy(() =>
    import("@/utils/UserRegistrationOffer")
);
const TimerPromotionPopup = React.lazy(() =>
    import("@/utils/TimerPromotionPopup")
);
const CustomPricePlan = React.lazy(() =>
    import("@/components/settings/pricingPlans/CustomPricePlan")
);
const AppsMarket = React.lazy(() =>
    import("@/components/AppsMarket/AppsMarket")
);
const AppsModal = React.lazy(() => import("@/components/AppsMarket/AppsModal"));
// const ReportingDashboard = React.lazy(() => import('@/components/ReportingDashboard'));
const CreateClientOrWebsite = React.lazy(() =>
    import("@/components/settings/CreateClientOrWebsite")
);
const ClientOrWebsiteDashboard = React.lazy(() =>
    import("@/components/dashboard/ClientOrWebsiteDashboard")
);
const GroupClientAndPropertyDashboard = React.lazy(() =>
    import("@/components/dashboard/GroupClientAndPropertyDashboard")
);
const CreateGroupClientAndProperties = React.lazy(() =>
    import("@/components/settings/CreateGroupClientAndProperties")
);
const TalkToSales = React.lazy(() =>
    import("@/components/settings/pricingPlans/TalkToSales")
);
const UserStartupConfigurationModal = React.lazy(() =>
    import("@/helpers/UserStartupConfigurationModal")
);
const GlobalAIChatButton = React.lazy(() =>
    import("@/components/shared/GlobalAIChatButton")
);

// const name = React.lazy(() => import('@/'));

// import ReportingDashboard from "./components/ReportingDashboard";

function isFreeEmail(email = "") {
    const parts = email.split("@");
    const domain = parts.length > 1 ? parts[1] : null;
    if (
        !domain ||
        domain === "gmail.com" ||
        domain === "yahoo.com" ||
        domain === "hotmail.com" ||
        domain === "outlook.com" ||
        domain === "aol.com"
    ) {
        return true;
    }
    return false;
}

class Main extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: undefined,
            showStartupConfiguration: false,
            showInterfaceTour: false,
            showPasswordPopup: false,
            showDataSourceTour: false,
            showPromotionPopup: false,
            showTimerPromotionPopup: false,
            mKeyAnnotation: "",
            showManualClientOrWebsitePopup: false,
            showGroupClientAndPropertiesPopup: false,
            showUpgradePopup: false,
            colorChangeRandomKey: "",
            upgradePopupType: "",
            upgradePopupButtonText:
                '<a href="https://calendly.com/crystal-ball/30min" target="_blank" class="btn-bookAdemo">Book a Demo</a>',
            csvUploadPopupSize: "md upload-csv",
            isSidebarCollapsed: false,
        };
        this.loadUser = this.loadUser.bind(this);

        // this.toggleStartupConfiguration = this.toggleStartupConfiguration.bind(this);
        this.toggleInterfaceTour = this.toggleInterfaceTour.bind(this);
        this.toggleDataSourceTour = this.toggleDataSourceTour.bind(this);
        this.togglePromotionPopup = this.togglePromotionPopup.bind(this);
        this.toggleTimerPromotionPopup =
            this.toggleTimerPromotionPopup.bind(this);
        this.extendTrial = this.extendTrial.bind(this);
        this.saveVisitLog = this.saveVisitLog.bind(this);
        this.shouldOpenStartupConfigurationModal =
            this.shouldOpenStartupConfigurationModal.bind(this);
        this.shouldOpenAddWebsiteModal =
            this.shouldOpenAddWebsiteModal.bind(this);
    }

    toggleStartupConfiguration() {
        this.setState({
            showStartupConfiguration: !this.state.showStartupConfiguration,
            showInterfaceTour: !this.state.showInterfaceTour,
        });
    }

    toggleInterfaceTour(keepInterfaceTour = false) {
        // If the user has alive registration offers and interface tour is showing
        if (
            this.state.user.user_registration_offers.length &&
            this.state.showInterfaceTour
        ) {
            setTimeout(() => {
                this.setState({ showTimerPromotionPopup: true });
            }, 60000);
        }
        this.setState({
            showInterfaceTour: !this.state.showInterfaceTour,
            showDataSourceTour: !this.state.showDataSourceTour,
        });
        this.loadUser(false, keepInterfaceTour, false);
    }

    toggleDataSourceTour() {
        this.setState({ showDataSourceTour: !this.state.showDataSourceTour });
        this.loadUser(false, false, false);
    }

    togglePromotionPopup() {
        this.setState({ showPromotionPopup: !this.state.showPromotionPopup });
    }

    toggleTimerPromotionPopup() {
        this.setState({
            showTimerPromotionPopup: !this.state.showTimerPromotionPopup,
        });
    }

    extendTrial() {
        HttpClient.post("extend-trial").then((response) => {
            swal.fire("Extended", response.data.message, "success");
            this.loadUser();
        });
    }

    saveVisitLog(page) {
        HttpClient.post(`save-visit-log`, {
            page_name: page,
        })
            .then(
                (resp) => {},
                (err) => {}
            )
            .catch((err) => {});
    }

    shouldOpenStartupConfigurationModal = () => {
        const { showPasswordPopup, user, showStartupConfiguration } =
            this.state;
        const isFreeEmailWithNoWebsite =
            !user?.website &&
            (isFreeEmail(user?.email) || user?.is_login_with_google);
        return (
            !showPasswordPopup &&
            !isFreeEmailWithNoWebsite &&
            showStartupConfiguration &&
            !showPasswordPopup &&
            !isFreeEmailWithNoWebsite
        );
        // return (!showPasswordPopup && !isFreeEmailWithNoWebsite && showStartupConfiguration) || (!showPasswordPopup && !isFreeEmailWithNoWebsite && !user.last_logged_into_extension_at);
    };

    shouldOpenAddWebsiteModal = () => {
        const { showPasswordPopup, user } = this.state;
        const isFreeEmailWithNoWebsite =
            !user.website &&
            (isFreeEmail(user.email) || user.is_login_with_google);
        return !showPasswordPopup && !user.user_id && isFreeEmailWithNoWebsite;
    };

    render() {
        if (this.state.user == undefined) return null;

        if (
            [
                "/settings",
                "/settings/price-plans",
                "/settings/profile",
                "/settings/support",
                "/settings/price-plans/payment",
                "/settings/payment-history",
                "/settings/payment-detail/create",
            ].indexOf(this.props.location.pathname) == -1 &&
            this.state.user.price_plan.name == "Trial Ended"
        ) {
            // return <Redirect to={"/settings/price-plans"}/>
        }

        if (
            ["/settings/change-password"].indexOf(
                this.props.location.pathname
            ) == -1 &&
            this.state.user.do_require_password_change == true
        ) {
            return <Redirect to={"/settings/change-password"} />;
        }
        return (
            <Layout
                style={{
                    minHeight: "100vh",
                }}
                className="bg-white"
            >
                {this.state.showPasswordPopup ? (
                    <AddNewPasswordModal
                        show={this.state.showPasswordPopup}
                        reloadUser={this.loadUser}
                        user={this.state.user}
                    />
                ) : null}

                {this.shouldOpenAddWebsiteModal() ? (
                    <AddWebsiteModal
                        reloadUser={this.loadUser}
                        show={this.shouldOpenAddWebsiteModal()}
                        user={this.state.user}
                    />
                ) : null}

                {/* <InterfaceTour isOpen={this.state.showInterfaceTour} toggleShowTour={this.toggleInterfaceTour} /> */}

                {this.shouldOpenStartupConfigurationModal() ? (
                    <UserStartupConfigurationModal
                        upgradePopup={(popupType) =>
                            this.setState({
                                showUpgradePopup: true,
                                upgradePopupType: popupType,
                            })
                        }
                        reloadUser={this.loadUser}
                        showDataSourceTour={this.state.showDataSourceTour}
                        toggleDataSourceTour={this.toggleDataSourceTour}
                        saveVisitLog={this.saveVisitLog}
                        closeModal={() =>
                            this.setState({
                                showStartupConfiguration: false,
                                showTimerPromotionPopup:
                                    !!this.state.user.user_registration_offers
                                        .length,
                            })
                        }
                        isOpen={this.shouldOpenStartupConfigurationModal()}
                        user={this.state.user}
                    />
                ) : null}

                <header
                    id={"gaa-header"}
                    className={
                        "gaa-header top-0 sticky left-0 w-full z-[999] bg-white"
                    }
                >
                    <SiteRenamedTopNotice show={true} />

                    {this.state.user.user_registration_offers.map((uRO) => (
                        <React.Fragment key={uRO.id}>
                            <TimerPromotionPopup
                                show={this.state.showTimerPromotionPopup}
                                togglePopupCallback={
                                    this.toggleTimerPromotionPopup
                                }
                                promotionLink="/settings/price-plans"
                                promotionImage="/images/35-off-24-hours.webp"
                                userRegistrationOffer={uRO}
                            />
                            <UserRegistrationOffer
                                userRegistrationOffer={uRO}
                                show={true}
                            />
                        </React.Fragment>
                    ))}
                    <Header
                        passwordPopupOpen={this.state.showPasswordPopup}
                        websiteModalOpen={this.shouldOpenAddWebsiteModal()}
                        startupConfigOpen={this.shouldOpenStartupConfigurationModal()}
                        user={this.state.user}
                        extendTrial={this.extendTrial}
                        openAnnotationPopup={(mka) => {
                            this.setState({ mKeyAnnotation: mka });
                        }}
                        onSidebarCollapse={(value) =>
                            this.setState({ isSidebarCollapsed: value })
                        }
                    />
                </header>
                {/* <PromotionPopup show={this.state.showPromotionPopup} togglePopupCallback={this.togglePromotionPopup} promotionLink="https://appsumo.8odi.net/crystal-ball" promotionImage="/images/crystal-ball-promotion.jpg" /> */}
                <Layout className="bg-white">
                    <Sidebar
                        openAnnotationPopup={(mka) => {
                            this.setState({ mKeyAnnotation: mka });
                        }}
                        user={this.state.user}
                        reloadUser={this.loadUser}
                        toggleInterfaceTour={this.toggleInterfaceTour}
                        onSidebarCollapse={(value) =>
                            this.setState({ isSidebarCollapsed: value })
                        }
                    />
                    <Layout.Content className={`bg-white px-4`}>
                        <Switch>
                            <Route exact path="/ga-accounts" refresh={true}>
                                <IndexDashboard
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                />
                            </Route>
                            <Route exact path="/talk-to-sales">
                                <TalkToSales />
                            </Route>

                            <Route
                                exact
                                path="/manual-client-website"
                                refresh={true}
                            >
                                <ClientOrWebsiteDashboard
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                    toggleManualClientOrWebsitePopup={() => {
                                        this.setState({
                                            showManualClientOrWebsitePopup:
                                                !this.state
                                                    .showManualClientOrWebsitePopup,
                                        });
                                    }}
                                />
                            </Route>
                            <Route
                                exact
                                path="/group-properties-clients"
                                refresh={true}
                            >
                                <GroupClientAndPropertyDashboard
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                    toggleGroupClientAndPropertiesPopup={() => {
                                        this.setState({
                                            showGroupClientAndPropertiesPopup:
                                                !this.state
                                                    .showGroupClientAndPropertiesPopup,
                                        });
                                    }}
                                />
                            </Route>
                            <Route exact path="/ai-insights" refresh={true}>
                                <IndexInsightsAI
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    openAnnotationPopup={(mka) => {
                                        this.setState({ mKeyAnnotation: mka });
                                    }}
                                    user={this.state.user}
                                    mKeyAnnotation={this.state.mKeyAnnotation}
                                    reloadUser={this.loadUser}
                                />
                            </Route>
                            <Route
                                exact
                                path="/settings/analytics-accounts"
                                refresh={true}
                            >
                                <IndexDashboard
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                />
                            </Route>
                            <Route
                                exact
                                path="/dashboard/analytics"
                                refresh={true}
                            >
                                <IndexAnalytics
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    openAnnotationPopup={(mka) => {
                                        this.setState({ mKeyAnnotation: mka });
                                    }}
                                    user={this.state.user}
                                    mKeyAnnotation={this.state.mKeyAnnotation}
                                    reloadUser={this.loadUser}
                                />
                            </Route>
                            {/*<Route exact path="/dashboard/search-console" refresh={true}>
                                <IndexSearchConsole upgradePopup={(popupType) => this.setState({
                                    showUpgradePopup: true,
                                    upgradePopupType: popupType
                                })} user={this.state.user}/>
                            </Route>*/}

                            <Route exact path="/annotation" refresh={true}>
                                <IndexAnnotations
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    openAnnotationPopup={(mka) => {
                                        this.setState({ mKeyAnnotation: mka });
                                    }}
                                    user={this.state.user}
                                    saveVisitLog={this.saveVisitLog}
                                    mKeyAnnotation={this.state.mKeyAnnotation}
                                    colorChangeRandomKey={
                                        this.state.colorChangeRandomKey
                                    }
                                />
                            </Route>
                            {/*<Route exact path="/report-dashboard" refresh={true}>
                                <ReportingDashboard user={this.state.user}/>
                            </Route>*/}
                            {/*<Route exact path="/annotation/create" refresh={true}>
                                <AnnotationsCreate upgradePopup={(popupType) => this.setState({
                                    showUpgradePopup: true,
                                    upgradePopupType: popupType
                                })} currentPricePlan={this.state.user.price_plan}/>
                            </Route>*/}
                            {/*<Route exact path="/annotation/:id?/edit" refresh={true} render={(routeParams) =>
                                <AnnotationsUpdate upgradePopup={(popupType) => this.setState({
                                    showUpgradePopup: true,
                                    upgradePopupType: popupType
                                })} routeParams={routeParams} currentPricePlan={this.state.user.price_plan}/>}
                            >
                            </Route>*/}
                            <Route exact path="/api-key" refresh={true}>
                                <IndexAPIKey
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    currentPricePlan={
                                        this.state.user.price_plan
                                    }
                                    saveVisitLog={this.saveVisitLog}
                                />
                            </Route>
                            {/*<Route exact path="/annotation/upload" refresh={true}>
                                <AnnotationsUpload upgradePopup={(popupType) => this.setState({
                                    showUpgradePopup: true,
                                    upgradePopupType: popupType
                                })} currentPricePlan={this.state.user.price_plan}/>
                            </Route>*/}
                            <Route exact path="/data-source" refresh={true}>
                                <AppsMarket
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                    reloadUser={this.loadUser}
                                    saveVisitLog={this.saveVisitLog}
                                    showDataSourceTour={
                                        this.state.showDataSourceTour
                                    }
                                    toggleDataSourceTour={
                                        this.toggleDataSourceTour
                                    }
                                />
                                {/* <DataSourceIndex user={this.state.user} reloadUser={this.loadUser} showDataSourceTour={this.state.showDataSourceTour} toggleDataSourceTour={this.toggleDataSourceTour} /> */}
                            </Route>
                            {/*<Route exact path="/data-source-old" refresh={true}>
                                <DataSourceIndex upgradePopup={(popupType) => this.setState({
                                    showUpgradePopup: true,
                                    upgradePopupType: popupType
                                })} user={this.state.user} reloadUser={this.loadUser}
                                                 showDataSourceTour={this.state.showDataSourceTour}
                                                 toggleDataSourceTour={this.toggleDataSourceTour}/>
                            </Route>*/}
                            <Route exact path="/integrations" refresh={true}>
                                <IntegrationsIndex
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                />
                            </Route>
                            <Route exact path="/my-integrations" refresh={true}>
                                <MyIntegrationsIndex
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                />
                            </Route>
                            <Route
                                exact
                                path="/analytics-and-business-intelligence"
                                refresh={true}
                            >
                                <AnalyticsAndBusinessIntelligenceIndex
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                />
                            </Route>
                            <Route exact path="/notifications" refresh={true}>
                                <IndexNotificationSettings
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                    saveVisitLog={this.saveVisitLog}
                                    reloadUser={this.loadUser}
                                />
                            </Route>
                            <Route exact path="/settings" refresh={true}>
                                <Settings
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                />
                            </Route>
                            <Route
                                exact
                                path="/settings/profile"
                                refresh={true}
                            >
                                <Profile
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                    saveVisitLog={this.saveVisitLog}
                                    reloadUser={this.loadUser}
                                />
                            </Route>
                            <Route
                                exact
                                path="/settings/price-plans"
                                refresh={true}
                            >
                                {/*<TalkToSales/>*/}
                                <IndexPricingPlans
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                    saveVisitLog={this.saveVisitLog}
                                />
                            </Route>
                            <Route
                                exact
                                path="/settings/price-plans/payment"
                                refresh={true}
                            >
                                <CreatePayment
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                    saveVisitLog={this.saveVisitLog}
                                />
                            </Route>
                            <Route
                                exact
                                path="/settings/payment-history"
                                refresh={true}
                            >
                                <PaymentHistory
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                />
                            </Route>
                            {/*<Route exact path="/settings/payment-detail/create" refresh={true}>
                                <CreatePaymentDetail upgradePopup={(popupType) => this.setState({
                                    showUpgradePopup: true,
                                    upgradePopupType: popupType
                                })} user={this.state.user}/>
                            </Route>*/}
                            <Route exact path="/accounts" refresh={true}>
                                <Accounts
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    toggleManualClientOrWebsitePopup={() => {
                                        this.setState({
                                            showManualClientOrWebsitePopup:
                                                !this.state
                                                    .showManualClientOrWebsitePopup,
                                        });
                                    }}
                                    user={this.state.user}
                                    saveVisitLog={this.saveVisitLog}
                                    reloadUser={this.loadUser}
                                />
                            </Route>
                            {/*<Route exact path="/settings/facebook-accounts" refresh={true}>
                                <FacebookAccounts upgradePopup={(popupType) => this.setState({
                                    showUpgradePopup: true,
                                    upgradePopupType: popupType
                                })} user={this.state.user} reloadUser={this.loadUser}/>
                            </Route>*/}
                            {/*<Route exact path="/settings/devices" refresh={true}>
                                <UserDevices upgradePopup={(popupType) => this.setState({
                                    showUpgradePopup: true,
                                    upgradePopupType: popupType
                                })} user={this.state.user} reloadUser={this.loadUser}/>
                            </Route>*/}
                            <Route
                                exact
                                path="/tm/ui-task-board"
                                refresh={true}
                            >
                                <TaskBoard
                                    upgradePopup={() =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType:
                                                "has_task_management",
                                        })
                                    }
                                    user={this.state.user}
                                    reloadUser={this.loadUser}
                                />
                            </Route>
                            <Route
                                exact
                                path="/tm/ui-boards/:id"
                                refresh={true}
                            >
                                <BoardDetail
                                    upgradePopup={() =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType:
                                                "has_task_management",
                                        })
                                    }
                                    user={this.state.user}
                                    reloadUser={this.loadUser}
                                />
                            </Route>

                            <Route
                                exact
                                path="/settings/activity-log"
                                refresh={true}
                            >
                                <UserActivityLog
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                    reloadUser={this.loadUser}
                                />
                            </Route>
                            <Route
                                exact
                                path="/settings/support"
                                refresh={true}
                            >
                                <SupportIndex
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                    saveVisitLog={this.saveVisitLog}
                                />
                            </Route>
                            <Route exact path="/settings/user" refresh={true}>
                                <IndexUsers
                                    upgradePopup={(popupType) =>
                                        this.setState({
                                            showUpgradePopup: true,
                                            upgradePopupType: popupType,
                                        })
                                    }
                                    user={this.state.user}
                                    saveVisitLog={this.saveVisitLog}
                                />
                            </Route>
                            {/*<Route exact path="/settings/user/create" refresh={true}>
                                <CreateUser
                                    upgradePopup={(popupType) => this.setState({
                                        showUpgradePopup: true,
                                        upgradePopupType: popupType
                                    })} user={this.state.user}
                                    currentPricePlan={this.state.price_plan}
                                />
                            </Route>*/}
                            {/*<Route exact path="/settings/user/:id?/edit" refresh={true}
                                   render={(routeParams) => <EditUser upgradePopup={(popupType) => this.setState({
                                       showUpgradePopup: true,
                                       upgradePopupType: popupType
                                   })} routeParams={routeParams}/>}
                                   currentPricePlan={this.state.user.price_plan}
                            />*/}
                            <Route
                                exact
                                path="/settings/custom-price-plan/:code?"
                                refresh={true}
                                render={(routeParams) => (
                                    <CustomPricePlan
                                        upgradePopup={(popupType) =>
                                            this.setState({
                                                showUpgradePopup: true,
                                                upgradePopupType: popupType,
                                            })
                                        }
                                        routeParams={routeParams}
                                        currentPricePlan={
                                            this.state.user.price_plan
                                        }
                                        user={this.state.user}
                                    />
                                )}
                            ></Route>
                        </Switch>
                        {/* <CreatePayment upgradePopup={(popupType) => this.setState({showUpgradePopup: true, upgradePopupType: popupType})} user={this.state.user} /> */}
                    </Layout.Content>
                    <Footer />
                </Layout>

                {this.state.mKeyAnnotation === "manual" ? (
                    <ModalAntd
                        title={
                            <span className="text-[#096db7] text-2xl">
                                Add annotation manually
                            </span>
                        }
                        footer={null}
                        open={this.state.mKeyAnnotation === "manual"}
                        width={`600px`}
                        onCancel={(mka = "") => {
                            this.setState({ mKeyAnnotation: mka });
                        }}
                    >
                        <AnnotationsCreate
                            upgradePopup={(popupType) =>
                                this.setState({
                                    showUpgradePopup: true,
                                    upgradePopupType: popupType,
                                })
                            }
                            togglePopup={(mka) => {
                                this.setState({ mKeyAnnotation: mka });
                            }}
                            currentPricePlan={this.state.user.price_plan}
                            user={this.state.user}
                            onColorChangeRandomKey={(value) => {
                                this.setState({ colorChangeRandomKey: value });
                            }}
                        />
                    </ModalAntd>
                ) : this.state.mKeyAnnotation === "upload" ? (
                    <AppsModal
                        popupSize={this.state.csvUploadPopupSize}
                        isOpen={
                            this.state.mKeyAnnotation === "manual" ||
                            this.state.mKeyAnnotation === "upload"
                        }
                        toggle={(mka = "") => {
                            this.setState({
                                mKeyAnnotation: mka,
                                csvUploadPopupSize: "md upload-csv",
                            });
                        }}
                    >
                        <AnnotationsUpload
                            updateCSVUploadStep={(csvUploadPopupSize) =>
                                this.setState({ csvUploadPopupSize })
                            }
                            upgradePopup={(popupType) =>
                                this.setState({
                                    showUpgradePopup: true,
                                    upgradePopupType: popupType,
                                })
                            }
                            togglePopup={(mka) => {
                                this.setState({
                                    mKeyAnnotation: mka,
                                    csvUploadPopupSize: "md upload-csv",
                                });
                            }}
                            currentPricePlan={this.state.user.price_plan}
                        />
                    </AppsModal>
                ) : null}

                <AppsModal
                    isOpen={this.state.showManualClientOrWebsitePopup}
                    toggle={() => {
                        this.setState({
                            showManualClientOrWebsitePopup:
                                !this.state.showManualClientOrWebsitePopup,
                        });
                    }}
                    popupSize={"md"}
                >
                    <CreateClientOrWebsite
                        togglePopup={() => {
                            this.setState({
                                showManualClientOrWebsitePopup:
                                    !this.state.showManualClientOrWebsitePopup,
                            });
                        }}
                    />
                </AppsModal>

                <AppsModal
                    isOpen={this.state.showGroupClientAndPropertiesPopup}
                    toggle={() => {
                        this.setState({
                            showGroupClientAndPropertiesPopup:
                                !this.state.showGroupClientAndPropertiesPopup,
                        });
                    }}
                    popupSize={"md"}
                >
                    <CreateGroupClientAndProperties
                        togglePopup={() => {
                            this.setState({
                                showGroupClientAndPropertiesPopup:
                                    !this.state
                                        .showGroupClientAndPropertiesPopup,
                            });
                        }}
                        currentPricePlan={this.state.user.price_plan}
                    />
                </AppsModal>

                <Modal
                    isOpen={this.state.showUpgradePopup}
                    centered
                    className="gaUpgradePopup"
                    toggle={() =>
                        this.setState({
                            showUpgradePopup: false,
                            upgradePopupType: "",
                        })
                    }
                >
                    <button
                        onClick={() =>
                            this.setState({
                                showUpgradePopup: false,
                                upgradePopupType: "",
                            })
                        }
                        class="btn-closeUpgradePopup"
                    >
                        <img src="/images/close.svg" alt="close icon" />
                    </button>
                    {this.state.upgradePopupType === "api-upgrade" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade to access <span>API Functionality</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/apiFunctionality.svg"
                            okButtonText="Talk to Sales"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "has_task_management" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade to access <span>ToDo Functionality</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/apiFunctionality.svg"
                            okButtonText="Talk to Sales"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "news-alert" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Increase your credits limits to add more <span>News Alerts</span></h1>`}
                            subHeading={`<p>Upgrade to get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/news-upgrade.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "rank-tracking-access" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade to access <span>Rank Tracking (SERP)</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/rank-tracking-upgrade.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "rank-tracking" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Increase your credits limits to add more <span>Rank Trackers</span></h1>`}
                            subHeading={`<p>Upgrade to get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/rank-tracking-upgrade.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType ===
                    "website-monitoring-upgrade" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade today to add <span>Website Monitors</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/web-monitor-upgrade.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType ===
                    "website-monitoring-limit" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Increase your credits limits to add more <span>Website Monitors</span></h1>`}
                            subHeading={`<p>Upgrade to get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/web-monitor-limit-increase.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType ===
                    "add-more-than-one-property" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade to add <span>more than one</span> property</h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/more-property-upgrade.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "add-more-property" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade today to add <span>more properties</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/more-property-upgrade.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "more-users" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade today and add <span>more users</span> to your company account</h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/more-users.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "more-annotations" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade today to add <span>more annotations</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/more-annotations.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "integrations" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade today to access <span>integrations</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/more-integrations.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "get-notifications" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade today to <span>get notifications</span> via Email, SMS, and Push</h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/get-notifications.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "podcast-trackers" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade to add more <span>Podcast Trackers</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/podcast-trackers.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "increase-limits" ? (
                        <ga-upgrade-popup
                            heading={`<h1>You've reached your plan limits! Upgrade to  <span>increase limits</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/increase-limits.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "more-repositories" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade today to track  <span>more repositories</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/more-repositories.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "social-media" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade today to access  <span>social media</span> tracking and insights</h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/social-media.svg"
                        ></ga-upgrade-popup>
                    ) : null}

                    {this.state.upgradePopupType === "ads-trackers" ? (
                        <ga-upgrade-popup
                            heading={`<h1>Upgrade today to add more  <span>Ads Trackers</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            button={this.state.upgradePopupButtonText}
                            bannerImg="/images/trackers-ads.svg"
                        ></ga-upgrade-popup>
                    ) : null}
                    {this.state.upgradePopupType === "trial-ended" ? (
                        <ga-extend-trail-popup
                            heading={`<h1>Trial Ended > <span>Upgrade Today</span></h1>`}
                            subHeading={`<p>and get access to all amazing features</p>`}
                            bannerImg="/images/more-property-upgrade.svg"
                        ></ga-extend-trail-popup>
                    ) : null}

                    {this.state.upgradePopupType === "console-modal" ? (
                        <ConsoleSiteModal
                            upgradePopup={(popupType) =>
                                this.setState({
                                    showUpgradePopup: true,
                                    upgradePopupType: popupType,
                                })
                            }
                            closeModal={() =>
                                this.setState({ showConsolePopup: false })
                            }
                            isOpen={
                                this.state.upgradePopupType === "console-modal"
                            }
                            user={this.state.user}
                        />
                    ) : null}
                </Modal>
                {/* <Modal isOpen={true} centered className="gaUpgradePopup" toggle={() => {}}>
                    <button onClick={() => {}} class="btn-closeUpgradePopup"></button>

                    <ga-extend-trail-popup
                        heading={`<h1>Trial Ended > <span>Upgrade Today</span></h1>`}
                        subHeading={`<p>and get access to all amazing features</p>`}
                        bannerImg="/images/more-property-upgrade.svg"
                    ></ga-extend-trail-popup>
                </Modal> */}

                {/* Global AI Chat Button - appears on all pages except ai-insights */}
                {this.props.location.pathname !== "/ai-insights" && (
                    <GlobalAIChatButton />
                )}
            </Layout>
        );
    }

    componentDidMount() {
        // const {SVGInjector} = window.SVGInjector
        // SVGInjector(document.getElementsByClassName('inject-me'), {
        //     cacheRequests: false,
        //     evalScripts: 'once',
        //     httpRequestWithCredentials: false,
        //     renumerateIRIElements: false
        // })

        // let loader = document.getElementById("loader");
        // loader.classList.remove("fadeOut")
        this.loadUser();
        console.log("Pusher Beamers Start");
        window.beamsTokenProvider = new PusherPushNotifications.TokenProvider({
            url: "/beaming/auth",
            queryParams: {
                // someQueryParam: "parameter-content", // URL query params your auth endpoint needs
            },
            headers: {
                // someHeader: "header-content", // Headers your auth endpoint needs
            },
        });
        console.log(window.beamsTokenProvider);
        console.log("Pusher Beamers Going");
        window.beamsClient = new PusherPushNotifications.Client({
            instanceId:
                process.env.MIX_PUSHER_BEAMS_INSTANCE_ID ||
                "4d56d4d5-c518-4c90-81ca-9de8913194bc",
        });
        console.log(window.beamsClient);
        console.log("Pusher Beamers End");
    }

    loadUser(
        keepStartupConfiguration = false,
        keepInterfaceTour = false,
        keepDataSourceTour = false
    ) {
        HttpClient.get("/user")
            .then(
                (response) => {
                    const annotations_count =
                        response.data.user.annotations_count;
                    const annotations_limit =
                        response.data.user.price_plan.annotations_count;
                    const annotations_limit_reached =
                        annotations_count > annotations_limit &&
                        annotations_limit > 0;
                    this.setState({
                        user: response.data.user,
                        // These states were in use when user startup configuration wizard was enabled
                        showStartupConfiguration:
                            !!response.data.user.show_config_steps,
                        showPasswordPopup:
                            response.data.user.show_password_message,
                        // showInterfaceTour: keepInterfaceTour ? true : (response.data.user.startup_configuration_showed_at !== null && response.data.user.last_login_at == null),
                        // showDataSourceTour: keepDataSourceTour ? true : (response.data.user.startup_configuration_showed_at !== null && response.data.user.last_login_at !== null && response.data.user.data_source_tour_showed_at == null),
                        showInterfaceTour: keepInterfaceTour
                            ? true
                            : response.data.user.last_login_at == null,
                        showDataSourceTour: keepDataSourceTour
                            ? true
                            : response.data.user.last_login_at !== null &&
                              response.data.user.data_source_tour_showed_at ==
                                  null,
                        showUpgradePopup: annotations_limit_reached,
                        upgradePopupType: "increase-limits",
                    });
                    loader.classList.add("fadeOut");

                    if (response.data.user.last_login_at == null) {
                        if (typeof gtag === "function") {
                            gtag("event", "conversion", {
                                send_to: "AW-645973826/wQD3CJnzvugBEMKOg7QC",
                            });
                        } else {
                            console.warn("gtag is not loaded.");
                        }

                        if (typeof ga === "function") {
                            ga("send", {
                                hitType: "event",
                                eventCategory: "SignUp",
                                eventAction: "SignUp",
                                eventLabel: "SignUp",
                            });
                        } else {
                            console.warn("ga is not loaded.");
                        }

                        if (typeof fpr === "function") {
                            fpr("referral", {
                                uid: "{{ Auth::user()->id }}",
                            });
                        } else {
                            console.warn("fpr is not loaded.");
                        }
                    }
                    if (response.data.user.trail_plan_status == true) {
                        this.setState({ showUpgradePopup: true });
                        this.setState({ upgradePopupType: "trial-ended" });
                    }
                    if (
                        response.data.user.price_plan.code === "free new" &&
                        (!response.data.user.price_plan_settings ||
                            response.data.user.price_plan_settings
                                .extended_trial.activation_count < 1)
                    ) {
                        this.setState({
                            upgradePopupButtonText:
                                '<a  href="/settings/price-plans"  class="btn-bookAdemo">Extend my Trial</a>',
                        });
                    }
                    if (response.data.user.price_plan.name == "Trial Ended") {
                        this.setState({ showPasswordPopup: false });
                    }
                    if (response.data.user.price_plan.name == "Free") {
                        setTimeout(() => {
                            this.setState({ showPromotionPopup: true });
                        }, 5000);
                    }

                    // HttpClient.post(`/settings/price-plan/check-extra-apps`, {
                    //     '_token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    //     'price_plan_id': response.data.user.price_plan.id,
                    // })
                    //     .then(response => {
                    //         this.setState({isBusy: false, errors: undefined});
                    //         response.data.alertText.forEach(text => {
                    //             // swal.fire('Oops...', text, 'info');
                    //         });
                    //     }, (err) => {
                    //         this.setState({isBusy: false, errors: (err.response).data});
                    //     }).catch(err => {
                    //     this.setState({isBusy: false, errors: err});
                    // });
                },
                (err) => {
                    this.setState({ isBusy: false, errors: err.response.data });
                }
            )
            .catch((err) => {
                this.setState({ isBusy: false, errors: err });
            });
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged();
        }
    }

    onRouteChanged() {
        window.scrollTo(0, 0);
        let anchors = document.getElementsByTagName("a");
        for (var i = 0; i < anchors.length; ++i) {
            if (anchors[i].parentElement.localName == "li") {
                anchors[i].classList.remove("link-active");
                anchors[i].parentElement.classList.remove("link-active");
            } else {
                anchors[i].classList.remove("link-active");
            }
        }
        for (var i = 0; i < anchors.length; ++i) {
            if (anchors[i].href == window.location.href) {
                if (anchors[i].parentElement.localName == "li") {
                    anchors[i].classList.add("link-active");
                    anchors[i].parentElement.classList.add("link-active");
                } else {
                    anchors[i].classList.add("link-active");
                }
            }
        }
    }
}

export default Main;
